(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["smart-404-products"] && !Shopify.designMode) return;
  try {
    
(() => {
  const root = document.querySelector('[data-smart-404]');
  if (!root) return;

  let path = '';
  try { path = decodeURIComponent(window.location.pathname).toLowerCase(); }
  catch (e) { path = window.location.pathname.toLowerCase(); }

  let handle = 'tout';
  let title = 'Découvrez nos produits';
  let text = 'Voici une sélection pour poursuivre votre visite.';

  const hasAny = (terms) => terms.some((term) => path.includes(term));

  if (hasAny(['vie-intense', 'collection-privee', 'collection-privée'])) {
    handle = 'collection-daliali';
    title = 'Découvrez la Collection Daliali';
    text = 'Le produit recherché n’est plus disponible. Voici des parfums de notre collection susceptibles de vous plaire.';
  } else if (hasAny(['kailoa', 'botox', 'lissage', 'capillaire'])) {
    handle = 'kailoa';
    title = 'Découvrez nos soins Kaïloa';
    text = 'Le produit recherché n’est plus disponible. Voici une sélection de soins capillaires proches.';
  } else if (hasAny(['brume', 'body-mist', 'bodymist'])) {
    handle = 'brumes';
    title = 'Découvrez nos brumes parfumées';
    text = 'Le produit recherché n’est plus disponible. Voici des brumes proches de votre recherche.';
  } else if (hasAny(['lattafa', 'dubai', 'dubaï', 'musc', 'parfum', 'eau-de-parfum'])) {
    handle = 'parfums';
    title = 'Découvrez nos parfums';
    text = 'Le produit recherché n’est plus disponible. Voici une sélection de parfums à découvrir.';
  }

  const target = root.querySelector('[data-smart-404-group="' + handle + '"]') ||
    root.querySelector('[data-smart-404-group="tout"]');

  if (target) target.hidden = false;

  const heading = root.querySelector('[data-smart-404-title]');
  const paragraph = root.querySelector('[data-smart-404-text]');
  const link = root.querySelector('[data-smart-404-link]');

  if (heading) heading.textContent = title;
  if (paragraph) paragraph.textContent = text;
  if (link) {
    link.href = (window.Shopify?.routes?.root || '/') + 'collections/' + handle;
    link.textContent = handle === 'tout' ? 'Parcourir la boutique' : 'Voir toute la sélection';
  }
})();

  } catch(e) { console.error(e); }
})();
})();
